module.exports = __webpack_public_path__ + "img/boiling-green-patch.0e55e741.png";